// extracted by mini-css-extract-plugin
export default {"selectInput":"SelectInput_selectInput__Dskyi"};